// todo: implement util functions with predefined formats
export const formatToLocaleString = (dt: Date, locale = 'en-US'): string => {
  return dt.toLocaleString(locale);
};

export const getStringFromDate = (dt: Date): string => new Date(dt).toDateString();
